import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgReferral = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M8.99999 4.29069C9.28897 4.29069 9.52324 4.52496 9.52325 4.81395V5.03494C10.6608 5.23861 11.6163 6.09321 11.6163 7.25581C11.6163 7.54479 11.382 7.77907 11.093 7.77907C10.804 7.77906 10.5698 7.54479 10.5698 7.25581C10.5698 6.66678 9.96035 6.03489 8.99999 6.03489C8.03963 6.03489 7.43022 6.66678 7.43022 7.25581C7.43023 7.84483 8.03963 8.47673 8.99999 8.47673C10.3516 8.47673 11.6163 9.40665 11.6163 10.7442C11.6163 11.9068 10.6608 12.7613 9.52325 12.965V13.186C9.52324 13.475 9.28897 13.7093 8.99999 13.7093C8.71101 13.7093 8.47674 13.475 8.47673 13.186V12.965C7.33921 12.7613 6.38372 11.9068 6.38371 10.7442C6.38371 10.4552 6.61798 10.2209 6.90697 10.2209C7.19595 10.2209 7.43022 10.4552 7.43022 10.7442C7.43023 11.3332 8.03964 11.9651 8.99999 11.9651C9.96034 11.9651 10.5697 11.3332 10.5698 10.7442C10.5698 10.1552 9.96035 9.52325 8.99999 9.52325C7.64841 9.52324 6.38372 8.59334 6.38371 7.25581C6.38371 6.09322 7.33921 5.23861 8.47673 5.03494V4.81395C8.47674 4.52496 8.71101 4.29069 8.99999 4.29069Z",
			fill: "white",
			fillOpacity: .74
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M8.99999 1.5C13.1421 1.5 16.5 4.85786 16.5 8.99999C16.5 13.1421 13.1421 16.5 8.99999 16.5C4.85786 16.5 1.5 13.1421 1.5 8.99999C1.5 4.85786 4.85786 1.5 8.99999 1.5ZM8.99999 2.54651C5.43583 2.54651 2.54651 5.43583 2.54651 8.99999C2.54652 12.5641 5.43583 15.4535 8.99999 15.4535C12.5641 15.4535 15.4535 12.5641 15.4535 8.99999C15.4535 5.43583 12.5641 2.54651 8.99999 2.54651Z",
			fill: "white",
			fillOpacity: .74
		})
	]
});
const ForwardRef = forwardRef(SvgReferral);
export { ForwardRef as ReactComponent };
